var map = {
	"./1945.ts": [
		9002,
		9002
	],
	"./1975.ts": [
		53695,
		3695
	],
	"./56.ts": [
		66657,
		6657
	],
	"./97.ts": [
		77952,
		7952
	],
	"./index.ts": [
		88175
	],
	"./type.ts": [
		78128,
		8128
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79419;
module.exports = webpackAsyncContext;